"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty2(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PageView = void 0;
var _requester = require("../requester"),
  _types = require("./types"),
  _types2 = require("../types");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var PageView = /*#__PURE__*/function () {
  function PageView(a) {
    _classCallCheck(this, PageView);
    var b = a.urlAddress,
      c = a.title,
      d = a.referrers;
    _defineProperty(this, "timestamps", void 0), _defineProperty(this, "urlAddress", void 0), _defineProperty(this, "title", void 0), _defineProperty(this, "nonce", void 0), _defineProperty(this, "referrers", void 0), this.urlAddress = b, this.title = c, this.referrers = d, this.timestamps = [{
      time: Date.now(),
      status: _types2.TrackingStatus.Unsent
    }];
  }
  return _createClass(PageView, [{
    key: "url",
    get: function get() {
      var a;
      if (!this.urlAddress) return "";
      var b = this.title ? _requester.UrlParameter.Title + encodeURIComponent(this.title) : "",
        c = null !== (a = this.referrers) && void 0 !== a && a.length ? _requester.UrlParameter.ReferrersIndices + JSON.stringify(this.referrers) : "";
      return _requester.UrlEventType.Page + _requester.UrlParameter.Href + encodeURIComponent(this.urlAddress) + b + c;
    }
  }, {
    key: "status",
    get: function get() {
      var _this$timestamps$redu = this.timestamps.reduce(function (a, b) {
          var c = b.status;
          return a[c] = !0, a;
        }, _defineProperty2(_defineProperty2(_defineProperty2({}, _types2.TrackingStatus.Sent, !1), _types2.TrackingStatus.Unsent, !1), _types2.TrackingStatus.Pending, !1)),
        a = _this$timestamps$redu[_types2.TrackingStatus.Sent],
        b = _this$timestamps$redu[_types2.TrackingStatus.Unsent],
        c = _this$timestamps$redu[_types2.TrackingStatus.Pending];
      return !a || b || c ? c && !b ? _types2.TrackingStatus.Pending : _types2.TrackingStatus.Unsent : _types2.TrackingStatus.Sent;
    },
    set: function set(a) {
      this.timestamps = this.timestamps.map(function (b) {
        return _objectSpread(_objectSpread({}, b), {}, {
          status: a
        });
      });
    }
  }, {
    key: "_nonce",
    set: function set(a) {
      this.nonce = a;
    }
  }, {
    key: "data",
    get: function get() {
      return {
        urlAddress: this.urlAddress,
        title: this.title,
        referrers: this.referrers,
        type: _types.KameleoonData.PageView,
        timestamps: this.timestamps,
        status: this.status,
        nonce: this.nonce
      };
    }
  }], [{
    key: "_fromRaw",
    value: function _fromRaw(a) {
      var b = a.urlAddress,
        c = a.title,
        d = a.referrers,
        e = a.timestamps,
        f = a.nonce,
        g = new PageView({
          urlAddress: b,
          title: c,
          referrers: d
        });
      return g.timestamps = e, f && (g._nonce = f), g;
    }
  }, {
    key: "_updateFromVisit",
    value: function _updateFromVisit(a, b) {
      var c = a.pageEvents;
      if (c) {
        var _iterator = _createForOfIteratorHelper(c),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _a = _step.value;
            var _c = [];
            var d = _a.time,
              _a$data = _a.data,
              e = _a$data.href,
              f = _a$data.title,
              g = _a$data.referrersIndices;
            "number" == typeof g[0] && (_c = g);
            var h = void 0;
            if (b.has(e)) {
              var _a2 = b.get(e).timestamps;
              h = new PageView({
                urlAddress: e,
                title: f,
                referrers: _c
              }), h.timestamps = [].concat(_toConsumableArray(_a2), [{
                time: d,
                status: _types2.TrackingStatus.Sent
              }]);
            } else h = new PageView({
              urlAddress: e,
              title: f,
              referrers: _c
            }), h.timestamps = [{
              time: d,
              status: _types2.TrackingStatus.Sent
            }];
            b.set(e, h);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);
}();
exports.PageView = PageView;